import React, { useEffect } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

const ThankYou = () => {
    const { search } = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(search);

    const type = params.get("type") || "general";
    const tech = params.get("tech") || "";
    const page = params.get("page") || "";

    // 🔥 Conversion Tracking (Important)
    useEffect(() => {
        const eventKey = `lead_fired_${type}_${tech}_${page}`;

        if (!sessionStorage.getItem(eventKey)) {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
                event: "lead_submission",
                form_type: type,
                technology: tech,
                source_page: page,
            });

            sessionStorage.setItem(eventKey, "true");
        }
    }, [type, tech, page]);

    const contentMap = {
        "hire-developer": {
            title: "Developer Hiring Request Received",
            message: `Your request to hire a ${tech} developer has been received.`,
            subText:
                "Our team will review your requirements and contact you within 24 hours.",
        },
        general: {
            title: "Thank You for Contacting Us!",
            message: "Your enquiry has been submitted successfully.",
            subText:
                "Our team will get back to you shortly regarding your request.",
        },
    };

    const content = contentMap[type] || contentMap.general;

    const openChatra = (e) => {
        e.preventDefault();
        if (window.Chatra) {
            window.Chatra("openChat", true);
        }
    };


    return (
        <section className="thank-you-page py-5 bg-light">
            <Container>
                <Row className="justify-content-center text-center">
                    <Col lg={7}>
                        <Card className="p-4 shadow-sm border-0 rounded-4">

                            <div className="mb-4">
                                <div
                                    className="d-flex align-items-center justify-content-center mx-auto"
                                    style={{
                                        width: "80px",
                                        height: "80px",
                                        borderRadius: "50%",
                                        backgroundColor: "#e6f9f0",
                                        fontSize: "32px",
                                        color: "#28a745",
                                        fontWeight: "bold"
                                    }}
                                >
                                    ✓
                                </div>
                            </div>

                            <h1 className="mb-3">{content.title}</h1>

                            <h5 className="mb-3">{content.message}</h5>
                            <p className="text-muted">{content.subText}</p>

                            <hr className="my-4" />

                            <p className="mb-3">Need immediate assistance?</p>

                            <div className="d-flex justify-content-center gap-3 flex-wrap">
                                <Button
                                    variant="primary"
                                    onClick={openChatra}
                                >
                                    Chat with an Expert
                                </Button>

                                <Button
                                    variant="outline-secondary"
                                    onClick={() => navigate("/")}
                                >
                                    Back to Home
                                </Button>
                            </div>

                            <p className="text-muted mt-4 small">
                                We respect your privacy. Your information is secure with us.
                            </p>

                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ThankYou;